import { Flex, Text } from '@chakra-ui/react';
import { Badge, Link } from '@morressier/alembic';
import { OrcidIcon } from '../AuthorInfo';
import { getOrcidUrl } from 'src/utils/utils';

export type RenderFieldProps = {
  label: string;
  value?: string | string[] | null;
  type?: string;
  badge: string;
};

type RenderOrcidIconProps = {
  value: string;
};

export const OrcidIDIcon = ({ value }: RenderOrcidIconProps) => {
  const orcidUrl = getOrcidUrl(value);

  return orcidUrl ? (
    <Link isExternal variant="primary" href={orcidUrl}>
      <OrcidIcon />
    </Link>
  ) : (
    <OrcidIcon />
  );
};

export const RenderField = ({
  label,
  value,
  type,
  badge
}: RenderFieldProps) => {
  const hasArrayValues =
    Array.isArray(value) &&
    value.length > 0 &&
    value.some(v => v && v.trim() !== '');
  const hasStringValue =
    typeof value === 'string' &&
    value.trim() !== '' &&
    value !== 'Invalid Date';

  return (
    <Flex direction="column" gap={1}>
      <Text textStyle="headingItem">
        {label}{' '}
        <Badge
          size="context"
          variant={badge === 'Previous' ? 'neutral' : 'attention'}
        >
          {badge}
        </Badge>
      </Text>
      {hasArrayValues ? (
        <Flex gap={2} wrap="wrap">
          {(value as string[]).map((val, idx) => (
            <Badge whiteSpace="normal" key={idx}>
              {val}
            </Badge>
          ))}
        </Flex>
      ) : hasStringValue && type === 'orcid' ? (
        <Flex alignItems={'center'} gap={1}>
          <OrcidIDIcon value={value} />
          <Text>{value}</Text>
        </Flex>
      ) : hasStringValue && type === 'url' ? (
        <Link href={value} variant="primary" target="_blank">
          {value}
        </Link>
      ) : hasStringValue ? (
        <Text>{value}</Text>
      ) : (
        <Text textStyle="textBody" color="GrayText">
          No data available
        </Text>
      )}
    </Flex>
  );
};
